// assets/gridlink-compare.js
;(function(window) {
  const STORAGE_KEY = 'gridlink_compare_products';

  function getList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch { return []; }
  }

  function saveList(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  }

  function addItem(item) {
    const list = getList();
    if (!list.some(i => i.handle === item.handle)) {
      list.push(item);
      saveList(list);
    }
  }

  function removeItem(handle) {
    const list = getList().filter(i => i.handle !== handle);
    saveList(list);
  }

  // Parse JSON-encoded meta values from data attributes
  function collectMeta(btn) {
    const meta = {};
    btn.getAttributeNames().forEach(attr => {
      if (attr.startsWith('data-meta-')) {
        const key = attr.slice('data-meta-'.length).replace(/-/g, '.');
        const raw = btn.getAttribute(attr);
        let parsed;
        try { parsed = JSON.parse(raw); } catch { parsed = raw; }
        meta[key] = parsed;
      }
    });
    console.log('[GridlinkCompare] collectMeta:', meta);
    return meta;
  }

  function initButtons() {
    document.querySelectorAll('.js-gridlink-compare-btn:not(.gridlink-compare-initialized)').forEach(btn => {
      btn.classList.add('gridlink-compare-initialized');
      const handle = btn.getAttribute('data-product-handle');
      const exists = getList().some(i => i.handle === handle);
      // btn.textContent = exists ? '➖ Compare' : '➕ Compare';
      btn.textContent = exists ? 'Remove From Compare' : 'Add To Compare';
      btn.addEventListener('click', () => {
        if (getList().some(i => i.handle === handle)) {
          removeItem(handle);
          // btn.textContent = '➕ Compare';
          btn.textContent = 'Add To Compare';
        } else {
          const meta = collectMeta(btn);
          addItem({ handle, meta });
          // btn.textContent = '➖ Compare';
          btn.textContent = 'Remove From Compare';
        }
      });
    });
    console.log('[GridlinkCompare] initButtons completed');
  }

  async function initComparePage(rootSelector, options) {
    console.log('[GridlinkCompare] initComparePage', options);
    const root = document.querySelector(rootSelector);
    if (!root) return console.warn('[GridlinkCompare] root not found:', rootSelector);

    const list = getList();
    console.log('[GridlinkCompare] initial storage list:', list);
    if (!list.length) {
      root.innerHTML = '<p>No products selected for comparison.</p>';
      return;
    }

    // Fetch core product JSON
    const products = await Promise.all(
      list.map(item =>
        fetch(`/products/${item.handle}.js`).then(res => res.ok ? res.json() : null).catch(() => null)
      )
    );
    console.log('[GridlinkCompare] fetched products:', products);

    // Add VAT if option is enabled
    if (options.includeVAT) {
      for (let i = 0; i < products.length; i++){
        // console.log('product price excl. VAT', products[i].price);
        products[i].price = products[i].price * 1.15;
        products[i].price = Math.ceil(products[i].price);
        // console.log('product price incl. VAT', products[i].price);
      } 
    }

    // Determine visible columns
    // Normalize metafields from Liquid to a real array
    const metafields = Array.isArray(options.metafields)
      ? options.metafields
      : (typeof options.metafields === 'string'
          ? (options.metafields.trim().startsWith('[')
              ? (() => { try { return JSON.parse(options.metafields) } catch(e) { return [] } })()
              : options.metafields.split(',').map(s => s.trim()).filter(Boolean))
          : []);

    const initialCols = [];
    if (options.showPrice) initialCols.push('price');
    metafields.forEach(m => initialCols.push(m));
    console.log('[GridlinkCompare] initialCols:', initialCols);
    const visibleCols = initialCols.filter(col => {
      if (col === 'price') return true;
      // normalize col to meta key by replacing hyphens with dots
      console.log('[GridlinkCompare] inner loop check one:', col);
      const metaKey = col.replace(/-/g, '.');
      console.log('[GridlinkCompare] inner loop check two:', list.some(item => item.meta[metaKey]));
      return list.some(item => item.meta[metaKey]);
    });
    console.log('[GridlinkCompare] visibleCols:', visibleCols);

    // Handle "Grid Layout (Style 1)"
    if (options.layoutType === 'grid') {
      // GRID LAYOUT
      root.innerHTML = '<div class="compare-grid">' +
        products.map((prod, idx) => {
          const { handle, meta } = list[idx];
          return `<div class="compare-card">
            <img src="${prod.featured_image}" alt="${prod.title}"/>
            <h3>${prod.title}</h3>
            ${options.showPrice ? `<p class="gl-compare-grid-price">R${(prod.price/100).toFixed(2)}</p>` : ''}
            ${visibleCols.filter(c => c !== 'price').map(col => {
               const metaKey = col.replace(/-/g,'.');
               let value = meta[metaKey];
               if (Array.isArray(value)) value = value.map(i=>i.label||i).join(', ');
               return `<div class="gl-compare-grid-meta-field"><strong>${col.replace(/^[^.]*\./,'')}</strong>: ${value||'N/A'}</div>`
            }).join('')}

            <button class="js-gridlink-remove remove-btn-grid-style" data-handle="${handle}">Remove Item From Compare</button>
            
          </div>`;
        }).join('') +
      '</div>';

      // Attach remove buttons on compare page
      root.querySelectorAll('.js-gridlink-remove').forEach(btn => {
        btn.addEventListener('click', () => {
          removeItem(btn.getAttribute('data-handle'));
          initComparePage(rootSelector, options);
        });
      });
      
      return;
    }

    // Handle "Grid Layout (Style 2)"
    if (options.layoutType === 'grid_2') {

      // GRID LAYOUT
      root.innerHTML = '<div class="compare-grid-style-2">' +
        products.map((prod, idx) => {
          const { handle, meta } = list[idx];
          return `<div class="compare-card">
            <a href="${prod.url}"><img src="${prod.featured_image}" alt="${prod.title}"/></a>
            <h3>${prod.title}</h3>
            ${options.showPrice ? `<p class="gl-compare-grid-price">R${(prod.price/100).toFixed(2)}</p>` : ''}
            ${visibleCols.filter(c => c !== 'price').map(col => {
               const metaKey = col.replace(/-/g,'.');
               let value = meta[metaKey];
               if (Array.isArray(value)) value = value.map(i=>i.label||i).join(', ');
               return `<div class="gl-compare-grid-meta-field"><strong>${col.replace(/^[^.]*\./,'')}</strong>: ${value||'N/A'}</div>`
            }).join('')}

            <button class="js-gridlink-remove remove-btn-grid-style" data-handle="${handle}">Remove Item From Compare</button>
            
          </div>`;
        }).join('') +
      '</div>';

      // Attach remove buttons on compare page
      root.querySelectorAll('.js-gridlink-remove').forEach(btn => {
        btn.addEventListener('click', () => {
          removeItem(btn.getAttribute('data-handle'));
          initComparePage(rootSelector, options);
        });
      });
      
      return;
    }

    ////// new code starts here
    // Spec-table layout branch (attributes as rows, products as columns)
    if (options.layoutType === 'table-attributes' || options.layoutType === 'spec') {
      // Header row: Attribute + one TH per product
      let specHead = '<tr><th>Product Link</th>';
      products.forEach((prod) => {
        if (prod) {
          // specHead += `<th><a href="${prod.url}">${prod.title}</a></th>`;
          specHead += `<th>
          <a href="${prod.url}">View Product</a>
          <button onclick="javascript:Quick();this.click()" style="margin-top:10px;" type="button" data-micromodal-trigger="quick-modal" data-src="${prod.url}?view=quick" class="quick btn auto-full-width" aria-label="Quick Shop">Quick Shop</button>
          </th>`;
        } else {
          specHead += '<th></th>';
        }
      });
      specHead += '</tr>';

      // Body rows
      let specBody = '';

      // Actions row (remove buttons)
      specBody += '<tr><th style="cursor:pointer" onclick="javascript:localStorage.removeItem(\'gridlink_compare_products\');window.location.href=window.location.href;">Remove All</th>';
      list.forEach((item) => {
        specBody += `<td><button class=\"js-gridlink-remove\" data-handle=\"${item.handle}\">X</button></td>`;
      });
      specBody += '</tr>';

      // Image row
      if (options.showImage) {
        specBody += '<tr><th>Image</th>';
        products.forEach((prod) => {
          if (prod) {
            specBody += `<td><a href="${prod.url}"><img src=\"${prod.featured_image || ''}\" alt=\"${prod.title}\" style=\"max-width:80px\"/></a></td>`;
          } else {
            specBody += '<td></td>';
          }
        });
        specBody += '</tr>';
      }

      // Title row
      specBody += '<tr><th>Title</th>';
      products.forEach((prod) => {
        if (prod) {
          specBody += `<td><a href=\"${prod.url}\">${prod.title}</a></td>`;
        } else {
          specBody += '<td></td>';
        }
      });
      specBody += '</tr>';

      // Description row
      if (options.showDescription) {
        specBody += '<tr><th>Description</th>';
        products.forEach((prod) => {
          specBody += `<td>${prod ? (prod.description || '') : ''}</td>`;
        });
        specBody += '</tr>';
      }

      // Price row
      if (options.showPrice) {
        specBody += '<tr><th>Price</th>';
        products.forEach((prod) => {
          const cell = prod && prod.price ? `R${(prod.price/100).toFixed(2)}` : '';
          specBody += `<td>${cell}</td>`;
        });
        specBody += '</tr>';
      }

      // Metafield rows (exclude price which is handled above)
      const metaKeys = visibleCols.filter(c => c !== 'price');
      metaKeys.forEach((col) => {
        const label = col.replace(/^[^.]*\./, '').replace(/_/g, ' ');
        const metaKey = col.replace(/-/g, '.');
        specBody += `<tr><th>${label}</th>`;
        list.forEach((item) => {
          // let cell = item.meta[metaKey] !== undefined ? item.meta[metaKey] : '';
          let cell = item.meta[metaKey] !== undefined ? item.meta[metaKey] : 'N/A';
          if (Array.isArray(cell)) {
            cell = cell.map(v => typeof v === 'object' ? (v.label || v.value || String(v)) : v).join(', ');
          }
          specBody += `<td>${cell}</td>`;
        });
        specBody += '</tr>';
      });

      root.innerHTML = `<table class=\"compare-table compare-table--spec\"><thead>${specHead}</thead><tbody>${specBody}</tbody></table>`;

      // Attach remove buttons
      root.querySelectorAll('.js-gridlink-remove').forEach(btn => {
        btn.addEventListener('click', () => {
          removeItem(btn.getAttribute('data-handle'));
          initComparePage(rootSelector, options);
        });
      });

      console.log('[GridlinkCompare] spec-table rendered');
      return;
    }
    ////// New code ends here
    
    // fall back to (default to) existing TABLE render code
    // Build table header row
    let header = '<tr><th>Actions</th>';
    if (options.showImage) header += '<th>Image</th>';
    header += '<th>Product</th>';
    if (options.showDescription) header += '<th>Description</th>';
    if (options.showPrice) header += '<th>Price</th>';
    visibleCols.filter(c => c !== 'price').forEach(col => {
      // normalize col to meta key
      const title = col.replace(/^[^.]*\./, '').replace(/_/g, ' ');
      header += `<th>${title}</th>`;
    });
    header += '</tr>';

    // Build table body rows
    let body = '';
    products.forEach((prod, idx) => {
      if (!prod) return;
      const { handle, meta } = list[idx];
      let row = '<tr>';
      row += `<td><button class="js-gridlink-remove" data-handle="${handle}">×</button></td>`;
      if (options.showImage) row += `<td><img src="${prod.featured_image||''}" alt="${prod.title}" style="max-width:80px"/></td>`;
      row += `<td><a href="${prod.url}">${prod.title}</a></td>`;
      if (options.showDescription) row += `<td>${prod.description||''}</td>`;
      if (options.showPrice) row += `<td>${prod.price ? `R${(prod.price/100).toFixed(2)}` : ''}</td>`;
      visibleCols.filter(c => c !== 'price').forEach(col => {
        const metaKey = col.replace(/-/g, '.');
        let cell = meta[metaKey] !== undefined ? meta[metaKey] : 'N/A';
        if (Array.isArray(cell)) {
          cell = cell.map(item => typeof item === 'object' ? (item.label || item.value || String(item)) : item).join(', ');
        }
        row += `<td>${cell}</td>`;
      });
      row += '</tr>';
      body += row;
    });

    root.innerHTML = `<table class=\"compare-table\"><thead>${header}</thead><tbody>${body}</tbody></table>`;

    // Attach remove buttons on compare page
    root.querySelectorAll('.js-gridlink-remove').forEach(btn => {
      btn.addEventListener('click', () => {
        removeItem(btn.getAttribute('data-handle'));
        initComparePage(rootSelector, options);
      });
    });

    console.log('[GridlinkCompare] table rendered');
  }

  document.addEventListener('DOMContentLoaded', initButtons);

  // re init buttons on product pages (related products load slowly...)
  if (window.location.href.split("/").indexOf("products") > -1){ window.onload = function(){ setTimeout(function(){ initButtons(); }, 1000) } } 

  window.GridlinkCompare = {
    init: function(config) {
      initButtons();
      if (config.comparePage && config.rootSelector) {
        initComparePage(config.rootSelector, config);
      }
    }
  };
})(window);